module.exports = __webpack_public_path__ + "img/logo-inverted.292da59.svg";